const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const activeAnimations = new Set();
const routines = new WeakSet();
const revealed = new WeakSet();
let keyboardMode = false;

function stopAnimations() {
  activeAnimations.forEach((animation) => animation.cancel());
  activeAnimations.clear();
}

function animate(element, frames, options) {
  if (reducedMotion.matches || keyboardMode || document.hidden || !element.animate) return;
  const animation = element.animate(frames, options);
  activeAnimations.add(animation);
  const finish = () => activeAnimations.delete(animation);
  animation.addEventListener('finish', finish, { once: true });
  animation.addEventListener('cancel', finish, { once: true });
  return animation;
}

const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  let stagger = 0;
  entries.forEach((entry) => {
    if (!entry.isIntersecting || revealed.has(entry.target)) return;
    revealed.add(entry.target);
    observer.unobserve(entry.target);
    const image = entry.target.dataset.avReveal === 'image';
    animate(entry.target, [
      { opacity: 0, transform: image ? 'translateY(12px) scale(.98)' : 'translateY(18px)' },
      { opacity: 1, transform: 'translateY(0) scale(1)' }
    ], { duration: 600, delay: Math.min(stagger++ * 60, 180), easing: 'cubic-bezier(0.23, 1, 0.32, 1)', fill: 'backwards' });
  });
}, { threshold: .08, rootMargin: '0px 0px -24px 0px' }) : null;

function init(scope = document) {
  scope.querySelectorAll('[data-av-reveal]').forEach((element) => {
    if (!element.parentElement.closest('[data-av-reveal]')) observer?.observe(element);
  });
  scope.querySelectorAll('[data-av-routine]').forEach((routine) => {
    if (routines.has(routine)) return;
    routines.add(routine);
    const buttons = [...routine.querySelectorAll('[data-av-step]')];
    const panels = [...routine.querySelectorAll('[data-av-panel]')];
    let current = panels.find((panel) => !panel.hidden);
    let panelAnimation;
    buttons.forEach((button) => {
      const next = panels.find((panel) => panel.dataset.avPanel === button.dataset.avStep);
      if (!next) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        if (next === current) return;
        panelAnimation?.cancel();
        current.hidden = true;
        current = next;
        current.hidden = false;
        buttons.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        panelAnimation = animate(current, [
          { opacity: .55, transform: 'translateY(8px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 220, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
      });
    });
  });
}

document.addEventListener('keydown', () => {
  keyboardMode = true;
  document.documentElement.dataset.avInput = 'keyboard';
  stopAnimations();
}, { passive: true });
document.addEventListener('pointerdown', () => {
  keyboardMode = false;
  document.documentElement.dataset.avInput = 'pointer';
}, { passive: true });
document.addEventListener('focusin', stopAnimations);
document.addEventListener('visibilitychange', () => { if (document.hidden) stopAnimations(); });
reducedMotion.addEventListener('change', stopAnimations);
document.addEventListener('shopify:section:load', (event) => init(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  stopAnimations();
  event.target.querySelectorAll('[data-av-reveal]').forEach((element) => observer?.unobserve(element));
});
init();

